import { lighten } from '@mui/material'
import { Theme } from '@mui/material/styles'

import {
  DELETED_ROW_CLASSNAME,
  FOUND_SEARCH_VALUE_CLASSNAME,
  PREV_SELECTED_ROW_CLASSNAME,
  SELECTED_ROW_CLASSNAME,
  UPDATES_ROW_CLASSNAME,
} from '@constants'

export const backgroundTableByMode = (wrapperClassName: string, theme: Theme) => {
  return {
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${UPDATES_ROW_CLASSNAME} > .MuiDataGrid-cell`]:
      {
        bgcolor: `${theme.palette.background.updatesRow}`,
      },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row > .MuiDataGrid-cell.${UPDATES_ROW_CLASSNAME}`]:
      {
        bgcolor: `${theme.palette.background.updatesRow}`,
      },
    [`& .MuiDataGrid-root .MuiDataGrid-cell.${FOUND_SEARCH_VALUE_CLASSNAME}`]: {
      bgcolor: `${theme.palette.background.searchValueRow}`,
    },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${DELETED_ROW_CLASSNAME} > .MuiDataGrid-cell`]:
      {
        bgcolor: `${lighten(theme.palette.error.light, 0.5)}`,
      },
    [`& .${SELECTED_ROW_CLASSNAME}, & .${SELECTED_ROW_CLASSNAME}.Mui-hovered`]: {
      '& > .MuiDataGrid-cell': {
        bgcolor: `${theme.palette.background.selectedRow}`,
      },
    },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${SELECTED_ROW_CLASSNAME} > .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${SELECTED_ROW_CLASSNAME} > .MuiDataGrid-cell--pinnedRight, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${SELECTED_ROW_CLASSNAME}.Mui-hovered > .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${SELECTED_ROW_CLASSNAME}.Mui-hovered > .MuiDataGrid-cell--pinnedRight`]:
      {
        bgcolor: `${theme.palette.background.selectedRow}`,
      },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${PREV_SELECTED_ROW_CLASSNAME} > .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${PREV_SELECTED_ROW_CLASSNAME} > .MuiDataGrid-cell--pinnedRight, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${PREV_SELECTED_ROW_CLASSNAME}.Mui-hovered > .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-row.${PREV_SELECTED_ROW_CLASSNAME}.Mui-hovered > .MuiDataGrid-cell--pinnedRight`]:
      {
        bgcolor: `${theme.palette.background.prevSelectedRow}`,
      },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${FOUND_SEARCH_VALUE_CLASSNAME}.MuiDataGrid-cell--pinnedRight`]:
      {
        bgcolor: `${theme.palette.background.searchValueRow}`,
      },
    [`& .MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root.MuiDataGrid-root .MuiDataGrid-cell.${FOUND_SEARCH_VALUE_CLASSNAME}.MuiDataGrid-cell--pinnedLeft`]:
      {
        bgcolor: `${theme.palette.background.searchValueRow}`,
      },
    [`& .${PREV_SELECTED_ROW_CLASSNAME} > .MuiDataGrid-cell`]: {
      bgcolor: `${theme.palette.background.prevSelectedRow}`,
    },
    ['& .MuiDataGrid-row.Mui-hovered > .MuiDataGrid-cell']: {
      bgcolor: `${theme.palette.background.hovered}`,
    },
    '& .even-row': {
      backgroundColor: `${theme.palette.background.evenRow}`,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: `${theme.palette.background.evenRow}`,
      },
    },
    '& .odd-row': {
      backgroundColor: `${theme.palette.background.oddRow}`,
      '& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight': {
        backgroundColor: `${theme.palette.background.oddRow}`,
      },
    },
    '&& .MuiDataGrid-row:hover .MuiDataGrid-cell': {
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
    },
  }
}
